/** Transient external-dependency failure — callers distinguish so a Circle/RPC outage doesn't skip-list legitimate transfers. */
export class CCTPTransientError extends Error {
  constructor(
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = "CCTPTransientError";
  }
}

export class CCTPProxyError extends CCTPTransientError {
  constructor(public readonly status: number) {
    super(`CCTP proxy error: ${status}`);
    this.name = "CCTPProxyError";
  }
}

/**
 * A burn was sent but we can't tell whether it landed and have no hash to track. Not safe to retry:
 * a second burn could withdraw the same funds twice.
 */
export class CctpBurnMayBeInFlightError extends Error {
  constructor(public readonly cause: unknown) {
    super("CCTP burn may have been submitted; its outcome is unknown");
    this.name = "CctpBurnMayBeInFlightError";
  }
}

export const isBurnMaybeInFlight = (error: unknown): error is CctpBurnMayBeInFlightError =>
  error instanceof CctpBurnMayBeInFlightError;

/** Circle's rate for the speed rose above the one the user was shown, so nothing was burned. */
export class CctpFeeChangedError extends Error {
  constructor() {
    super("Circle's fee went up since it was shown");
    this.name = "CctpFeeChangedError";
  }
}
